import HTTPClient from '@elab/core/utils/HTTPClient';
import apiUtils from '@elab/core/utils/apiUtils';
import cartApi from '@elab/core/store/cart/api';

const defaultCurrentPage = 0;
const defaultPageSize = 10;
const defaultFields = 'FULL';

async function fetchProductStock({
    productCode,
    latitude = 0.0,
    longitude = 0.0,
    query = '',
    currentPage = defaultCurrentPage,
    pageSize = defaultPageSize,
    fields = defaultFields,
}) {
    const url = buildProductStockUrl({
        latitude,
        longitude,
        query,
        currentPage,
        fields,
        pageSize,
        productCode,
    });
    const response = await HTTPClient().get(url);
    const resp = await response.json();
    if (!response.ok) {
        if (resp.errors[0].type === 'IllegalStateError') {
            throw makeFetchError({ productCode: '0000000', response: resp });
        } else {
            throw makeFetchError({ productCode, response });
        }
    }

    return resp;
}

function buildProductStockUrl({
    latitude,
    longitude,
    query,
    currentPage,
    fields,
    pageSize,
    productCode,
}) {
    const search = apiUtils.buildSearchString({
        latitude,
        longitude,
        location: query,
        currentPage,
        fields,
        pageSize,
    });

    return `${apiUtils.getBaseUri()}/products/${productCode}/stock?${search}`;
}

function makeFetchError({ productCode, response }) {
    if (productCode === '0000000') {
        return new Error(`${response.errors[0].message} rts-error-message`);
    }
    return new Error(`Unable to get Product("${productCode}") with status ("${response.status}")`);
}

const getCartProductsStock = async (
    userId,
    cartId,
    {
        latitude = 0.0,
        longitude = 0.0,
        query = '',
        currentPage = 0,
        pageSize = 10,
        fields = 'FULL',
    },
    handleError = false,
) => {
    const search = apiUtils.buildSearchString({
        latitude,
        longitude,
        query,
        currentPage,
        fields,
        pageSize,
    });

    const uri = `${cartApi.getCurrentCartApiService(userId, cartId)}/stores?${search}`;
    const response = await HTTPClient().get(uri);
    if (!handleError && !response.ok) {
        throw new Error(`Unable to get rts stores on Cart: (${response})`);
    }
    return await response.json();
};

const loadDeliveryModes = async (userId, cartId) => {
    const uri = `${cartApi.getCurrentCartApiService(userId, cartId)}/deliverymodes`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to get delivery modes (${response.status})`);
    }
    return await response.json();
};

export default {
    fetchProductStock,
    getCartProductsStock,
    loadDeliveryModes,
};
